import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IPrice } from "~/types/IPrice";
import { ServerResponse } from "~/types";

export const priceService = createApi({
  reducerPath: 'priceAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: '/'
  }),
  endpoints: build => ({
    getPrices: build.query<IPrice[], string>({
      query: () => ({
        url: `api/v1/billing/fee`
      }),
      transformResponse: (response: ServerResponse<IPrice>) => response.data.fee.services,
    })
  }),
})
